import { store } from 'store.js';
import axios from 'axios';
import { API_URL } from 'config.js';
import { caricamento, aggiornaLabels, errore, resetErrore } from 'features/labels/labelsSlice';

const API_LABELS_URL = `${API_URL}/generals/get_labels/`;
const API_FILE_LABEL_URL = `${API_URL}/generals/get_file_label/`;

// Funzione per convertire base64 in blob
const b64toBlob = (b64Data, contentType = 'image/png', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export async function richiediLabels() {
  store.dispatch(caricamento(true));
  store.dispatch(resetErrore());

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  try {
    const res = await axios.post(API_LABELS_URL, { utente, pin });

    const {
      data: { successo, dati = [], errore: messaggioErrore },
    } = res;

    if (successo) {
      store.dispatch(aggiornaLabels(dati ?? []));
      store.dispatch(resetErrore());
    } else {
      // Mostra sempre un errore quando successo è false
      const erroreMsg = messaggioErrore || 'Errore nel caricamento delle labels. La richiesta non è stata completata con successo.';
      store.dispatch(errore(erroreMsg));
      store.dispatch(aggiornaLabels([]));
    }
  } catch (error) {
    console.error('Error loading labels:', error);
    const erroreMsg = error.response?.data?.errore || error.message || 'Errore di connessione durante il caricamento delle labels';
    store.dispatch(errore(erroreMsg));
    store.dispatch(aggiornaLabels([]));
  }

  store.dispatch(caricamento(false));
}

export async function getFileLabel(ordine, codarticolo) {
  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  store.dispatch(caricamento(true));
  store.dispatch(resetErrore());

  try {
    const res = await axios.post(API_FILE_LABEL_URL, {
      utente,
      pin,
      ordine,
      codarticolo,
      tipo: 0,
    });

    const { successo, errore: messaggioErrore, file } = res.data;

    if (!successo) {
      const erroreMsg = messaggioErrore || 'Errore nel recupero del file label. La richiesta non è stata completata con successo.';
      store.dispatch(errore(erroreMsg));
      store.dispatch(caricamento(false));
      return;
    }

    if (file) {
      // Converti base64 in blob e apri in nuova finestra
      const fileBlob = b64toBlob(file, 'application/pdf');
      const fileUrl = URL.createObjectURL(fileBlob);
      window.open(fileUrl, '_blank');
    } else {
      store.dispatch(errore('Nessun file ricevuto dal server'));
    }

    store.dispatch(caricamento(false));
  } catch (error) {
    console.error('Error loading file label:', error);
    const erroreMsg = error.response?.data?.errore || error.message || 'Errore di connessione durante il recupero del file label';
    store.dispatch(errore(erroreMsg));
    store.dispatch(caricamento(false));
  }
}



